import babelpolyfill from 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import ElementUI, {Message} from 'element-ui'
import { Loading } from 'element-ui';


import  axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css'
//import './assets/theme/theme-green/index.css'
import VueRouter from 'vue-router'
import store from './vuex/store'
import Vuex from 'vuex'
import Base from './api/baseFun.js'
        //---------自定义的公共函数和公共请求方法
import Plugin from 'v-fit-columns';
Vue.use(Plugin);
import Print from 'vue-print-nb'
Vue.use(Print);

import routes from './routes'
import Mock from './mock'

//Mock.bootstrap();
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI)
Vue.use(VueRouter)
Vue.use(Vuex)

//NProgress.configure({ showSpinner: false });

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    //NProgress.start();
    console.log("----///-path----" + to.path);
    if (to.path == '/xieyi') {
            next();
    return;
    }
    if (to.path == '/login') {
        let user = JSON.parse(window.localStorage.getItem('user'));
        store.dispatch('SetRole', []);

        window.localStorage.removeItem('user');
    }
    let user = JSON.parse(window.localStorage.getItem('user'));
    if (!user && to.path != '/login') {
        next({path: '/login'});
    } else {
        if (user) {
            if (store.state.roles.length == 0) {
  next()
//                store.dispatch('GenerateRoutes', user.userRole).then(() => { // 根据roles权限生成可访问的路由表
//                    console.log('addrouters', store.getters.addRouters);
//                    router.addRoutes(store.getters.addRouters) ;// 动态添加可访问路由表
//                    next({...to, replace: true});// hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
//                })
            } else {
                next() // 当有用户权限的时候，说明所有可访问路由已生成 如访问没权限的全面会自动进入404页面
            }
        } else {
            next();
        }

    }
})

//router.afterEach(transition => {
//NProgress.done();
//});


let user = JSON.parse(window.localStorage.getItem('user'));

if (user) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.token;
       axios.defaults.headers.common['Token'] = user.token;
}
//将全局变量挂载到原型上
//Vue.prototype.baseApiUrl = _global.apiBaseUrl + _global.apiVerson;
var version = "/v1";

//Vue.prototype.baseApiUrl = "http:///localhost:8085" + version;
//Vue.prototype.baseApiUrl = "http:///localhost:8092" + version;//合伙人接口


//测试环境
//Vue.prototype.baseApiUrl = "http://uat-agx-par-api.pyaoyue.com" + version;//
Vue.prototype.baseApiUrl= "https://jiux.tccxtwas.com/api/";
Vue.prototype.baseApiUrl2= "https://jiux.tccxtwas.com/";
//Vue.prototype.baseApiUrl = "http://localhost:1002";
//Vue.prototype.baseApiUrl = "https://prod-agx-gateway.pyaoyue.com";
//Vue.prototype.baseApiUrl = "http://localhost:8384" + version;//

Vue.prototype.$axios = axios;//-----将封装的ajax请求函数注册到vue的全局
Vue.prototype.$store = store;//-----将封装的ajax请求函数注册到vue的全局
Vue.prototype.$loading = Loading;//-----将封装的ajax请求函数注册到vue的全局
//Vue.prototype.bus = new Vue;

Vue.prototype.baseFun = Base.baseFun;  //-----注册到vue的全局，方便各个组件和页面js调用公共函数
Vue.prototype.AGENT ="/agx-agent";  //-----注册到vue的全局，方便各个组件和页面js调用公共函数
Vue.prototype.AGXPARTNER ="/agx-partner";  //-----注册到vue的全局，方便各个组件和页面js调用公共函数
Vue.prototype.AGXCOLLEGE ="/agx-college";  //-----注册到vue的全局，方便各个组件和页面js调用公共函数
Vue.prototype.AGXRELATION="/agx-relation-cust";  //-----注册到vue的全局，方便各个组件和页面js调用公共函数
Vue.prototype.IMGDOMAIN="img.pyaoyue.com";  //图片路径
Vue.prototype.VEDEODOMAIN="video.pyaoyue.com";  //音频路径
Vue.prototype.OSSDOMAIN="ganxie.oss-cn-shenzhen.aliyuncs.com";  //oss






// 添加请求拦截器
axios.interceptors.request.use(function (config) {

    let user = JSON.parse(window.localStorage.getItem('user'));
    console.log("-----//1121");
    console.log(user);
    if (user) {
        config.headers.Authorization = 'Bearer ' + user.token;
        config.headers.Token = user.token;

    }
    console.log(config);
    return config;
}, function (error) {
    // 对请求失败做处理
    return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 对响应数据做处理
    console.log('返回');
    console.log(response);
    if(response.data.code==1){
    return response;
    }else{
    if(response.data.msg=='没有数据'){
    return;
    }
    //return response;
     Message({
            message:response.data.msg,
            type: 'error',
            duration: 5 * 1000
        })
    }
}, function (error) {
    // 对响应错误做处理
    //{"status": 401,"error": "Unauthorized","message": "未登录"}
    console.log('返回-错误');
    if (error.response) {

        switch (error.response.status) {
            case 400:
                //error.message = error.response.data[0].field + ":" + error.response.data[0].message;
                error.message = error.response.data[0].message;
                break;
            case 401:
                router.push({
                    path: '/login'
                })

                break;
            case 402:
                error.message = '用户名或者密码错误(402)';
                break;
                case 403:
                error.message = '拒绝访问(403)';
                break;
            case 404:
                error.message = '请求出错(404)';
                break;
            case 408:
                error.message = '请求超时(408)';
                break;
            default:
                if(error.response.data.message.indexOf("of underfind")<0){
                    error.message = error.response.data.message;
                }else{
                    error.message='网络异常';
                }

        }
        var _message = error.message;
        if (_message === undefined) {
            _message = `连接出错`;
        }
        Message({
            message: _message,
            type: 'error',
            duration: 5 * 1000
        })
    } else {
        error.message = `连接出错`;
        var _message = error.message;
        if (_message === undefined) {
            _message = `连接出错`;
        }
        Message({
            message: _message,
            type: 'error',
            duration: 5 * 1000
        })
    }
    return Promise.reject(error);
});

new Vue({
    //el: '#app',
    //template: '<App/>',
    router,
    store,
    //components: { App }
    render: h => h(App)
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js